/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Ai_Sign_In_ErrorInputs */

const en_read_along_ai_sign_in_error = /** @type {(inputs: Read_Along_Ai_Sign_In_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in again to generate insights.`)
};

const es_read_along_ai_sign_in_error = /** @type {(inputs: Read_Along_Ai_Sign_In_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuelve a iniciar sesión para generar información.`)
};

/**
* | output |
* | --- |
* | "Sign in again to generate insights." |
*
* @param {Read_Along_Ai_Sign_In_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_sign_in_error = /** @type {((inputs?: Read_Along_Ai_Sign_In_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_Sign_In_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_sign_in_error(inputs)
	return en_read_along_ai_sign_in_error(inputs)
});